const TypographyValues = Object.freeze({
    '--typography-1-font-size': '8px',
    '--typography-2-font-size': '10px',
    '--typography-3-font-size': '12px',
    '--typography-4-font-size': '14px',
    '--typography-5-font-size': '16px',
    '--typography-6-font-size': '20px',
    '--typography-7-font-size': '24px',
    '--typography-8-font-size': '30px',
    '--typography-9-font-size': '36px',
    '--typography-10-font-size': '42px',
    '--typography-11-font-size': '60px',
    '--typography-1-line-height': '10px',
    '--typography-2-line-height': '14px',
    '--typography-3-line-height': '16px',
    '--typography-4-line-height': '20px',
    '--typography-5-line-height': '24px',
    '--typography-6-line-height': '28px',
    '--typography-7-line-height': '32px',
    '--typography-8-line-height': '36px',
    '--typography-9-line-height': '48px',
    '--typography-10-line-height': '50px',
    '--typography-11-line-height': '72px',
});
const FontSizes = {
    s8: 'var(--typography-1-font-size)',
    s10: 'var(--typography-2-font-size)',
    s12: 'var(--typography-3-font-size)',
    s14: 'var(--typography-4-font-size)',
    s16: 'var(--typography-5-font-size)',
    s20: 'var(--typography-6-font-size)',
    s24: 'var(--typography-7-font-size)',
    s30: 'var(--typography-8-font-size)',
    s36: 'var(--typography-9-font-size)',
    s42: 'var(--typography-10-font-size)',
    s60: 'var(--typography-11-font-size)',
};
const LineHeights = {
    l10: 'var(--typography-1-line-height)',
    l14: 'var(--typography-2-line-height)',
    l16: 'var(--typography-3-line-height)',
    l20: 'var(--typography-4-line-height)',
    l24: 'var(--typography-5-line-height)',
    l28: 'var(--typography-6-line-height)',
    l32: 'var(--typography-7-line-height)',
    l36: 'var(--typography-8-line-height)',
    l48: 'var(--typography-9-line-height)',
    l50: 'var(--typography-10-line-height)',
    l72: 'var(--typography-11-line-height)',
};
const TypographyT1 = Object.freeze({
    fontSize: 'var(--typography-1-font-size)',
    lineHeight: 'var(--typography-1-line-height)',
});
const TypographyT2 = Object.freeze({
    fontSize: 'var(--typography-2-font-size)',
    lineHeight: 'var(--typography-2-line-height)',
});
const TypographyT3 = Object.freeze({
    fontSize: 'var(--typography-3-font-size)',
    lineHeight: 'var(--typography-3-line-height)',
});
const TypographyT4 = Object.freeze({
    fontSize: 'var(--typography-4-font-size)',
    lineHeight: 'var(--typography-4-line-height)',
});
const TypographyT5 = Object.freeze({
    fontSize: 'var(--typography-5-font-size)',
    lineHeight: 'var(--typography-5-line-height)',
});
const TypographyT6 = Object.freeze({
    fontSize: 'var(--typography-6-font-size)',
    lineHeight: 'var(--typography-6-line-height)',
});
const TypographyT7 = Object.freeze({
    fontSize: 'var(--typography-7-font-size)',
    lineHeight: 'var(--typography-7-line-height)',
});
const TypographyT8 = Object.freeze({
    fontSize: 'var(--typography-8-font-size)',
    lineHeight: 'var(--typography-8-line-height)',
});
const TypographyT9 = Object.freeze({
    fontSize: 'var(--typography-9-font-size)',
    lineHeight: 'var(--typography-9-line-height)',
});
const TypographyT10 = Object.freeze({
    fontSize: 'var(--typography-10-font-size)',
    lineHeight: 'var(--typography-10-line-height)',
});
const TypographyT11 = Object.freeze({
    fontSize: 'var(--typography-11-font-size)',
    lineHeight: 'var(--typography-11-line-height)',
});

export { FontSizes, LineHeights, TypographyT1, TypographyT10, TypographyT11, TypographyT2, TypographyT3, TypographyT4, TypographyT5, TypographyT6, TypographyT7, TypographyT8, TypographyT9, TypographyValues };
